class Tabs {
    constructor(tabsClass) {
        this.tabs = document.querySelector(`.${tabsClass}`);

        if (this.tabs) {
            this.tabButtons = Array.from(
                this.tabs.querySelectorAll('[role="tab"]'),
            );
            this.tabPanels = Array.from(
                this.tabs.querySelectorAll('[role="tabpanel"]'),
            );

            this.initTabindex();
            this.events();
        }
    }

    events() {
        this.tabButtons.forEach((button) => {
            button.addEventListener('click', this.handleTabClick.bind(this));
            button.addEventListener(
                'keydown',
                this.handleKeydown.bind(this),
            );
        });
    }

    initTabindex() {
        this.tabButtons.forEach((tab) => {
            tab.setAttribute(
                'tabindex',
                tab.getAttribute('aria-selected') === 'true' ? '0' : '-1',
            );
        });
    }

    switchTab(newTab) {
        this.tabPanels.forEach((panel) => {
            panel.hidden = true;
        });

        this.tabButtons.forEach((tab) => {
            tab.setAttribute('aria-selected', 'false');
            tab.setAttribute('tabindex', '-1');
        });

        newTab.setAttribute('aria-selected', 'true');
        newTab.setAttribute('tabindex', '0');
        newTab.focus();

        const tabPanel = this.tabPanels.find(
            (panel) => panel.getAttribute('aria-labelledby') === newTab.id,
        );
        tabPanel.hidden = false;
    }

    handleTabClick(event) {
        this.switchTab(event.currentTarget);
    }

    handleKeydown(event) {
        const index = this.tabButtons.indexOf(event.currentTarget);
        let newIndex;

        switch (event.key) {
            case 'ArrowRight':
                newIndex = (index + 1) % this.tabButtons.length;
                break;
            case 'ArrowLeft':
                newIndex =
                    (index - 1 + this.tabButtons.length) %
                    this.tabButtons.length;
                break;
            case 'Home':
                newIndex = 0;
                break;
            case 'End':
                newIndex = this.tabButtons.length - 1;
                break;
            default:
                return;
        }

        event.preventDefault();
        this.switchTab(this.tabButtons[newIndex]);
    }
}

export default Tabs;
